import axios from "axios";
import { BASE_URL } from "../Utils/base_url";
const LoginRestaurantRequest = async (data) => {
    return await axios.post(`${BASE_URL}/loginRestaurant`, data);
}
const ForgotRestaurant = async (data) => {
    return await axios.post(`${BASE_URL}/forgoutRestaurant`,data);
}
const ResetRestaurant = async (token,data) => {
    return await axios.post(`${BASE_URL}/resetRestaurant/${token}`,data);
}

const ForgotPasswordRestaurant = async (data) => {
    return await axios.post(`${BASE_URL}/forgotPasswordRestaurant`,data);
}

export {LoginRestaurantRequest, ForgotRestaurant,ResetRestaurant, ForgotPasswordRestaurant};